import * as React from 'react';
import {translate} from 'react-i18next';
import {Card} from 'semantic-ui-react';
import {ITranslatedComponent} from '../../redux/reducers/generalReducer';
import {TextPartition} from '../../services/Client';
import {ApprovalLongTextField} from './ApprovalLongTextField';
import {lang2flag} from '../../components/MultiLineColumn';
import ReactQuill from 'react-quill';
import {plainTextToQuillHtml} from 'src/components/Table/components/twoLanguage/EditorUtil';
import PromtFormatter from 'src/components/Table/components/reactQuill/PromtFormatter';

interface ITextPartitionContainerProps extends ITranslatedComponent {
    partitions: TextPartition[];
    prevPartitions?: TextPartition[];
    fluid?: boolean;
}

const TextPartitionContainer: React.StatelessComponent<ITextPartitionContainerProps> = (props: ITextPartitionContainerProps) => {
    const partitions: TextPartition[] = props.partitions;
    const prevPartitions = props.prevPartitions;
    const prevPartitionsMap: Map<string, TextPartition> = new Map();

    const shorttextCardDescriptions: JSX.Element[] = [];
    const longtextCardDescriptions: JSX.Element[] = [];
    const uspCardDescription: JSX.Element[] = [];
    const footerCardDescription: JSX.Element[] = [];

    if (prevPartitions) {
        prevPartitions.forEach(x => prevPartitionsMap.set(x.language || "", x));
    }

    partitions.forEach((partition: TextPartition, index: number) => {
        if (partition.language !== undefined && (partition.language === 'de' || partition.language === 'cc')) {
            const prevPartition = prevPartitionsMap.get(partition.language);

            shorttextCardDescriptions.push(
                <Card.Description key={`shorttext_${partition.language}_${index}`} >
                    <ApprovalLongTextField
                        iconClassName={`${lang2flag(partition.language)} flag`}
                        textChanged={prevPartition && prevPartition.shortText !== partition.shortText ? true : false}
                    >
                        {partition.shortText}
                    </ApprovalLongTextField>
                </Card.Description>
            );
            longtextCardDescriptions.push(
                <Card.Description key={`longtext_${partition.language}_${index}`} >
                    <ApprovalLongTextField
                        iconClassName={`${lang2flag(partition.language)} flag`}
                        textChanged={prevPartition && prevPartition.longText !== partition.longText ? true : false}
                    >
                        <PromtFormatter
                            className='no-border-quill'
                            value={partition.longText || ""}
                        />
                    </ApprovalLongTextField>
                </Card.Description>
            );
            if (partition.usp) {
                uspCardDescription.push(
                    <Card.Description key={`usp_${partition.language}_${index}`} >
                        <ApprovalLongTextField
                            iconClassName={`${lang2flag(partition.language)} flag`}
                            textChanged={prevPartition && prevPartition.usp !== partition.usp ? true : false}
                        >
                            <PromtFormatter
                                className='no-border-quill'
                                value={partition.usp || ""}
                            />
                        </ApprovalLongTextField>
                    </Card.Description>
                );
            }
            if (partition.footer) {
                footerCardDescription.push(
                    <Card.Description key={`footer_${partition.language}_${index}`} >
                        <ApprovalLongTextField
                            iconClassName={`${lang2flag(partition.language)} flag`}
                            textChanged={prevPartition && prevPartition.footer !== partition.footer ? true : false}
                        >

                            <PromtFormatter
                                className='no-border-quill'
                                value={partition.footer || ""}
                            />
                        </ApprovalLongTextField>
                    </Card.Description>
                );
            }
        }
    });

    return (
        <>
            <div>
                {shorttextCardDescriptions.length > 0 &&
                    <Card fluid={props.fluid}>
                        <Card.Content>
                            <Card.Meta>{props.t("SHORTTEXTS")}</Card.Meta>
                            {shorttextCardDescriptions}
                        </Card.Content>
                    </Card>
                }
                {longtextCardDescriptions.length > 0 &&
                    <Card fluid={props.fluid}>
                        <Card.Content>
                            <Card.Meta>{props.t("LONGTEXTS")}</Card.Meta>
                            {longtextCardDescriptions}
                        </Card.Content>
                    </Card>
                }
            </div>
            <div>
                {uspCardDescription.length > 0 &&
                    <Card fluid={props.fluid}>
                        <Card.Content>
                            <Card.Meta>{props.t("USP")}</Card.Meta>
                            {uspCardDescription}
                        </Card.Content>
                    </Card>
                }
                {footerCardDescription.length > 0 &&
                    <Card fluid={props.fluid}>
                        <Card.Content>
                            <Card.Meta>{props.t("FOOTER_TEXTS")}</Card.Meta>
                            {footerCardDescription}
                        </Card.Content>
                    </Card>
                }
            </div>
        </>
    );
};

export default translate(["APPROVAL_VIEW"])(TextPartitionContainer);



// WEBPACK FOOTER //
// ./src/views/ApprovalView/TextPartitionContainer.tsx